import React, { useId } from "react";
import { useTheme } from "../contexts/ThemeContext";

export default function ThemeToggle() {
  const id = useId();
  const { preference, setPreference } = useTheme();
  return (
    <div className="theme-setting">
      <span id={id}>Theme</span>
      <div className="theme-toggle" role="group" aria-labelledby={id}>
        {(["auto", "light", "dark"] as const).map(mode => (
          <button key={mode} type="button" aria-pressed={preference === mode}
            onClick={() => setPreference(mode)}>
            {mode === "auto" ? "Auto" : mode === "light" ? "Light" : "Dark"}
          </button>
        ))}
      </div>
    </div>
  );
}
